import {fromString} from '../../ToastMessage';

const loadField = async (placeholder) => {
    const url = placeholder.dataset.remoteOptionsUrl;

    if (!url) {
        return;
    }

    try {
        const response      = await fetch(url);
        const stringContent = await response.text();

        if (!response.ok) {
            fromString(stringContent);

            return;
        }

        const parsed = document.createElement('template');
        parsed.innerHTML = stringContent;

        placeholder.replaceWith(parsed.content);
    } catch {
        placeholder.textContent = placeholder.dataset.remoteOptionsError ?? '';
        placeholder.classList.add('status-message', 'error');
    }
};

export const initializeRemoteOptions = (scope) => {
    scope?.querySelectorAll('[data-remote-options-url]').forEach(loadField);
};
